import { setTrackLink, setTrackView } from '@vfit/shared/data-access';
import { removeCurrency } from '@vfit/consumer/hooks';
import { useTracking } from '@vfit/shared/data-access';
import { SoftManagerService } from '@vfit/consumer/providers';
import { useCoverageToolModalProvider } from '../../../coverageToolModal.context';
import { useQueryClient } from 'react-query';

const CoverageToolAutoTagging = () => {
  const client = useQueryClient();
  const { product } = useCoverageToolModalProvider();
  const pageProduct = {
    product_name: product?.slug,
    product_price: product?.price && removeCurrency(product.price),
    product_id: `${product?.offerId}`,
    product_quantity: '1',
    product_category: ['fixed'],
  };

  const opts = {
    event_category: 'tools',
    page_subsection: 'coverage tool',
    page_section: 'fixed offers',
    page_type: 'address',
    journey_name: 'coverage tool',
  };

  const { trackView } = useTracking({
    event: ['tool_start'],
    opts,
    pageProduct,
    visitorTrackingOpts: SoftManagerService(client).getUser(),
  });
  setTrackView(trackView);
  setTrackLink(trackView);

  return null;
};

export default CoverageToolAutoTagging;
